module.exports = __webpack_public_path__ + "77c81fe48608cae0e8a65fb8e4de99f1.svg";